import React from "react";
const AuthContext = React.createContext({
  userDetails: {},
  setUserDetails: () => {},
  displaySpinner: false,
  setDisplaySpinner: () => {},
});

export default AuthContext;
